import React, { useContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";

import "./PaymentSlip.css";
import { Table } from "react-bootstrap";
import { Context } from "../../../../utils/context";

const PaymentSlip = ({ show, onHide, setErr, slip }) => {

  const { IMG_URL } = useContext(Context);

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Payment Slip</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          {slip ? (
            <img
              src={IMG_URL + slip}
              style={{
                width: "auto",
                height: "500px",
                borderRadius: "50px",
              }}></img>
          ) : (
            "No Payment Slip Uploaded"
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSlip;
